import React from "react";
//#region components
import AgentAskForm from "./agentAskForm";
import AgentQuestionView from "./agentQuestionView";
import useAgentQuestion from "./useAgentQuestion";
//#endregion

interface AgentStepProps {
  /** The agent is switched off on the server: the popper falls back to the FAQ, as freshly opened. */
  onUnavailable: () => void;
  onOpenCase: (caseId: number) => void;
}

const AgentStep: React.FC<AgentStepProps> = (props) => {
  const { mode, onAsk, ...view } = useAgentQuestion(props);

  if (mode === "ask") return <AgentAskForm onSend={onAsk} />;

  return <AgentQuestionView mode={mode} {...view} />;
};

export default AgentStep;
